import { filterSpecBySkuModules, isSkuModuleEnabled } from '../../_shared/common/sku/skuEnabledModules';
import type { AppInstanceSpec } from './schema';

const MODULE_FIELD_STRIPS: Record<string, (spec: AppInstanceSpec) => AppInstanceSpec> = {
  baseInfo: (spec) => ({
    ...spec,
    alias: '',
    description: undefined,
    workspace: undefined,
  }),
  runtimeConfig: (spec) => ({
    ...spec,
    runtime: undefined,
  }),
  appService: (spec) => ({
    ...spec,
    framework: undefined,
  }),
  envVars: (spec) => ({
    ...spec,
    environment: undefined,
  }),
  service: (spec) => ({
    ...spec,
    network: spec.network
      ? {
          ...spec.network,
          service: undefined,
        }
      : undefined,
  }),
  healthCheck: (spec) => {
    const stripProbe = (group?: (typeof spec)['headGroupSpec']) => {
      if (!group?.system) return group;
      const system = { ...(group.system as Record<string, unknown>) };
      delete system.livenessProbe;
      const options = system.options as Record<string, unknown> | undefined;
      if (options?.containerDeployConfig) {
        try {
          const parsed =
            typeof options.containerDeployConfig === 'string'
              ? JSON.parse(options.containerDeployConfig)
              : { ...(options.containerDeployConfig as Record<string, unknown>) };
          delete parsed.healthCheck;
          system.options = { ...options, containerDeployConfig: JSON.stringify(parsed) };
        } catch {
          delete system.options;
        }
      }
      return { ...group, system };
    };
    return {
      ...spec,
      headGroupSpec: stripProbe(spec.headGroupSpec),
      workerGroupSpecs: spec.workerGroupSpecs?.map((group) => stripProbe(group)!),
    };
  },
  nodeGroups: (spec) => ({
    ...spec,
    headGroupSpec: undefined,
    workerGroupSpecs: undefined,
    runMode: undefined,
  }),
  /** 数据盘嵌在组 volumes 内；模块禁用时由 L3 reset 清表单，spec 层不做深剥离 */
  storage: (spec) => spec,
};

export function filterAppInstanceSpecByEnabledModules(
  spec: AppInstanceSpec,
  enabledModules?: Record<string, boolean>,
  skuType?: 'fixed' | 'custom',
): AppInstanceSpec {
  return filterSpecBySkuModules(spec, MODULE_FIELD_STRIPS, enabledModules, skuType);
}

export function isAppInstanceModuleEnabled(
  moduleKey: string,
  enabledModules?: Record<string, boolean>,
  skuType?: 'fixed' | 'custom',
): boolean {
  return isSkuModuleEnabled(moduleKey, enabledModules, skuType);
}
